import React from "react";
import { useNavigate } from "react-router-dom";
import RatingIndicator from "../RatingIndicator";
import styles from "../../../assets/styles/cardNews/CardVertical.module.css";
import thumbnail from "../../../assets/images/thumbnail_default.jpg";
import thumbnail2 from "../../../assets/images/thumbnail_default2.png";
import thumbnail3 from "../../../assets/images/thumbnail_default3.png";
import thumbnail4 from "../../../assets/images/thumbnail_default4.png";
import thumbnail5 from "../../../assets/images/thumbnail_default5.png";
import PressNDate from "./PressNDate";
import { Obscure } from "../\bobscuredImage";

const CardVertical = ({ news, main = "" }) => {
  const navigate = useNavigate();

  const moveToSingleNews = () => {
    if (news?.newstype === "E") {
      window.location.replace(`/dart-news/${news.newsid}`);
    } else if (news?.type === "A" || news?.type === "N") {
      // 폴리스타 - AI리포트인 경우 A타입, 직접 등록한 뉴스의 경우 N타입
      window.location.replace(`/polistar/${news?.objectid}`);
    } else {
      window.location.replace(`/single-news/${news.newsid}`);
    }
  };
  const moveToTimeline = () => {
    const state = { news: news };
    navigate(`/${news.newsid}/timeline`, { state: state });
  };

  const getRandomThumbnail = () => {
    const thumbnailList = [
      thumbnail,
      thumbnail2,
      thumbnail3,
      thumbnail4,
      thumbnail5,
    ];
    if (news.newstype === "E" || news.type === "A") {
      const idx = Math.floor(Math.random() * 4);
      return thumbnailList[idx];
    }
    return thumbnailList[0];
  };

  const getThumbnail = (nsSrc, poliSrc) => {
    if (!!nsSrc) {
      return nsSrc;
    } else if (!!poliSrc) {
      return poliSrc;
    } else {
      return null;
    }
  };

  return (
    <div className={`${styles.card_container} ${main}`}>
      <div
        className={styles.card_thumbnail_container}
        onClick={() => moveToSingleNews(news.newsid)}
      >
        <Obscure text={news?.press}>
          <img
            className={styles.thumbnail}
            src={
              news?.imgsrc || news?.img_url
                ? getThumbnail(news?.imgsrc, news?.img_url)
                : getRandomThumbnail()
            }
            alt={news.subject}
            onError={(e) => {
              e.target.src = thumbnail;
            }}
          />
        </Obscure>
      </div>
      <div className={styles.card_top}>
        <span className={styles.stockname}>{news?.stockname}</span>
        <RatingIndicator
          signal={news.signal}
          percent={news.staticsentimental?.percent}
        />
      </div>
      <div className={styles.card_content}>
        <div onClick={() => moveToSingleNews(news.newsid)}>
          <p className={styles.title}>{news.subject || news.title}</p>
          <p className={styles.summary}>{news.summary || news.content}</p>
        </div>
        <div className={styles.card_footer}>
          <PressNDate press={news.press} date={news.registdate} />
          {news?.samenewscounts > 0 && (
            <span className={styles.newscnt} onClick={moveToTimeline}>
              연관뉴스 {news.samenewscounts}건 보기 >{" "}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardVertical;
